import { createColumnHelper } from '@tanstack/react-table';

import { ContainerGroupRow } from '@/react/azure/types';

export const columnHelper = createColumnHelper<ContainerGroupRow>();
